import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { connectProps } from "store";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  langProp,
  productIDProp,
  userIDProp,
  email,
  collectionName,
} from "model/component-props";
import Modal from "react-responsive-modal";

import "../itemcard/itemCard.css";
import { styles } from "./style";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    //slidesToSlide: 3 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    //slidesToSlide: 3 // optional, default to 1.
  },
};

class CollectionCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      data: [],
      hover: false,
      itemVariant: [],
      photos: []
    };
  }

  onCloseModal = () => {
    this.setState({
      open: false,
    });
  };

  addDefaultSrc(ev) {
    ev.target.src = `${process.env.REACT_APP_NODE_SERVER}/notfound.png`;
    ev.target.onerror = null;
  }

  mouseOver = () => {
    this.setState({ hover: true });
  };
  mouseOut = () => {
    this.setState({ hover: false });
  };

  openModal = (id) => {
    this.setState({ open: true });
    fetch(`${process.env.REACT_APP_NODE_SERVER}/B2BItemVariantTranslation`, {
      crossDomain: true,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `No eq '${id}'`,
        username: this.props.email,
        id: id,
        collection: this.props.collectionName,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("HTTP error " + response.status);
      })
      .then((data) => {
        console.log(data);
        this.setState({
          itemVariant: data.value,
        });
      });

      const photos = [`${id}.JPG`.toLowerCase()]

      fetch(`${process.env.REACT_APP_NODE_SERVER}/getPhotosPerItem`, {
        crossDomain: true,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("HTTP error " + response.status);
        })
        .then((data) => {
          for(var i = 0; i<data.length; i++){
            photos.indexOf(data[i].toLowerCase()) === -1 ? photos.push(data[i].toLowerCase()) : console.log("This item already exists");
          }
        });

        this.setState({ photos: photos })
        
  };

  render() {
    const { url, id, description } = this.props;
    const colors = this.state.itemVariant || [];
    const { classes } = this.props;
    const { open } = this.state;
    const photos = this.state.photos || []

    console.log('photooooooos', this.state.photos)

    const PhotoItem = ({url}) => {
      return (
        <img
          src={url}
          onError={this.addDefaultSrc}
          alt="photoItem"
          style={{
            width: "500px",
            height: "600px",
            border: "1px solid #123C69",
          }}
        ></img>
      );
    };

    return (
      <div>
        <Card onClick={() => this.openModal(id)} className="itemCard-large">
          <CardContent>
            <div style={{ height: "106px" }}>
              <img
                onError={this.addDefaultSrc}
                src={url}
                alt=""
                style={{ width: "248px", height: "190px" }}
              ></img>
            </div>
            <table className="container-text">
              <tbody>
                <tr>
                  <td className="description-collection">
                    <b>{id}</b> {description}
                  </td>
                </tr>
              </tbody>
            </table>
          </CardContent>
        </Card>

        <Modal
          open={open}
          onClose={this.onCloseModal}
          closeOnEsc={true}
          closeOnOverlayClick={true}
          closeIconSize={30}
          showCloseIcon={true}
          center
        >
          <div style={{ width: "502px", marginTop: "24px" }}>
            <Carousel
              responsive={responsive}
              swipeable={false}
              draggable={false}
              showDots={true}
              ssr={false} 
              infinite={false}
              autoPlay={false}
              autoPlaySpeed={1000}
              keyBoardControl={true}
              customTransition="all .5"
              transitionDuration={500}
              containerClass="carousel-container"
              removeArrowOnDeviceType={["tablet", "mobile"]}
              deviceType={this.props.deviceType}
              dotListClass="custom-dot-list-style"
              itemClass="carousel-item-padding-40-px"
            >
            {
              photos.map(entry => {
                console.log('entry', entry)
                return (
                <div key={entry}>
                <PhotoItem url={`${process.env.REACT_APP_NODE_SERVER}/${entry}`} />
                {console.log(`${process.env.REACT_APP_NODE_SERVER}/${entry}`)}
                </div>
                )
                })
            }
            </Carousel>
            <p style={{fontSize: '14px'}}>Visualization of colour tones may be diverged</p>
            <div
              style={{
                width: "502px",
                margin: "5px",
                overflowWrap: "break-word",
              }}
            >
              <span style={{ fontWeight: "bold", color: "#123C69" }}>
                {this.props.langProp === "EN" ? "Colors: " : "Χρώματα: "}
              </span>
              {colors.map((color) => (
                <Button
                  className={classes.button}
                  variant="contained"
                  color="primary"
                >
                  <b>{color.Code}</b><span style={{paddingLeft:'5px'}}>{this.props.langProp === 'EN' ? color.ENUDescription_2 : color.ELLDescription_2}</span>
                </Button>
              ))}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

CollectionCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connectProps(
  langProp,
  productIDProp,
  userIDProp,
  email,
  collectionName
)(withStyles(styles)(CollectionCard));



// WEBPACK FOOTER //
// ./src/components/collectionCard/CollectionCard.js